import {createSlice} from "@reduxjs/toolkit";
import {setAppCategory, setAppDate} from "./actions";
import {getTransportCategory, startOfDay, transportCategory, TransportCategory} from "@ots-frontend/ots-data";

type UIState = {
  appDttm: number,
  appCategory: TransportCategory
}

const INITIAL_STATE: Readonly<UIState> = {
  appDttm: startOfDay(new Date()).getTime(),
  appCategory: getTransportCategory(import.meta.env.VITE_DEFAULT_APP_CATEGORY) ?? transportCategory.water
};

const uiSlice = createSlice({
  name: "ui",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setAppDate,
      (state, {payload}) => {
        state.appDttm = startOfDay(payload).getTime();
      }
    );
    builder.addCase(
      setAppCategory,
      (state, {payload}) => {
        state.appCategory = payload;
      }
    );
  }
});

export const uiReducer = uiSlice.reducer;
